// extracted by mini-css-extract-plugin
export default {"bd":"index_bd_AG6xP","space40":"index_space40_Jp9-k","space10":"index_space10_ObfWI"};